import { Time } from 'ohzi-core';

export default class FloorLight
{
  constructor(obj)
  {
    this.obj = obj;

    this.speed = Math.floor(Math.random() * 200) + 120;
    this.current_z_position = obj.position.z;
  }

  update()
  {
    // this.__update_obj_position();
  }

  __update_obj_position()
  {
    this.current_z_position -= Time.delta_time * this.speed;
    this.current_z_position = this.current_z_position > -100 ? this.current_z_position : 600;

    this.obj.position.set(this.obj.position.x, this.obj.position.y, this.current_z_position);
  }
}
